import React from "react";
import { Dalle } from "../base/Dalle";
import { FILM_CONFIG } from "./filmConfig";

export default function FilmDalle(props) {
  return (
    <Dalle
      {...props}
      workshopConfig={FILM_CONFIG.dalle}
      storageKey={FILM_CONFIG.storageKeys.dalleOutputs}
    />
  );
}
